import React, { useEffect, useState } from 'react';
import { API_BASE, SOCKET_URL } from '@/config/api';

const EnvDebugBanner: React.FC = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    try {
      const persisted = localStorage.getItem('env.debug.hide');
      if (persisted === '1') setHidden(true);
    } catch {}

    // Log values once
    console.log('Env Debug:', {
      MODE: import.meta.env.MODE,
      VITE_API_URL: import.meta.env.VITE_API_URL,
      API_BASE,
      SOCKET_URL,
    });
  }, []);

  if (import.meta.env.MODE === 'production' || hidden) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 12,
        left: 12,
        zIndex: 9999,
        background: 'rgba(15, 23, 42, 0.9)',
        color: '#e2e8f0',
        padding: '10px 12px',
        borderRadius: 8,
        fontSize: 12,
        boxShadow: '0 4px 14px rgba(0,0,0,0.3)'
      }}
      aria-label="Environment Debug"
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
        <strong style={{ color: '#93c5fd' }}>Env Debug</strong>
        <span style={{ marginLeft: 8, opacity: 0.8 }}>({import.meta.env.MODE})</span>
        <button
          onClick={() => {
            setHidden(true);
            try { localStorage.setItem('env.debug.hide', '1'); } catch {}
          }}
          style={{
            marginLeft: 10,
            background: 'transparent',
            border: 'none',
            color: '#cbd5e1',
            cursor: 'pointer'
          }}
          title="Hide"
        >
          ✕
        </button>
      </div>
      <div>API_BASE: <span style={{ color: '#fde68a' }}>{API_BASE}</span></div>
      <div>SOCKET_URL: <span style={{ color: '#fca5a5' }}>{SOCKET_URL}</span></div>
    </div>
  );
};

export default EnvDebugBanner;

